var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28a745",
    d: "M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M4 7h7v.5H4V7zm0 2h7v.5H4v-2zm0 2h7v.5H4v-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M4 6v6h.5V6H5zM7 6v6h.5V6H7zM9 6v6h.5V6H9zM11 6v6.5h.5V6h-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M4 6h7v.5H4V6zM4 8h7v.5H4V8zM4 10h7v.5H4V10zM4 12h7v.5H4V12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.ed148eed19cc95d4fa89a0d72536cd6f.svg";
export { ForwardRef as ReactComponent };